import moment from 'moment';

import { FINISHED_COUNTDOWN } from '@/modules/apr/countdown/constants';
import { CountdownInterface } from '@/types/aprRankings.types';

export const getCountdown = (targetDate: string | Date): CountdownInterface => {
  const now = moment();
  const target = moment(targetDate);

  const duration = moment.duration(target.diff(now));

  if (duration.asMilliseconds() <= 0) {
    return FINISHED_COUNTDOWN;
  }

  return {
    days: String(Math.floor(duration.asDays())),
    hours: String(duration.hours()).padStart(2, '0'),
    minutes: String(duration.minutes()).padStart(2, '0'),
    seconds: String(duration.seconds()).padStart(2, '0'),
  };
};
